import React, { useEffect, useRef, useState } from "react";
import { Header } from "../header";
import { Footer } from "../footer";
import axios from "axios";
import { Button, Input, message, Modal, Popover, Radio, Spin } from "antd";
import { ReactComponent as FilterIcon } from "../../../src/assets/images/filterIcon.svg";
import { CloseOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import "./products.css"
import greyImage from '../../assets/images/always-grey.png';
import { baseUrl } from "../../../src/config"

export const Products = () => {
  const { Search } = Input;
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [visible, setVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [popoverVisible, setPopovereVisible] = useState(false);
  const headerRef: any = useRef();
  const [firstResult, setFirstResult] = useState(0);
  const maxResult = 10; // fixed limit per page
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    quantity: "",
    email: "",
    notes: "",
    category_id: "",
    product_id: ""
  });
  const [expandedPreviews, setExpandedPreviews] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleTogglePreview = (productId) => {
    setExpandedPreviews((prev) => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const handleRadioChange = (e) => {
    setSelectedCategory(e.target.value);
    setPopovereVisible(false);
    setFirstResult(0); // Reset to first page when category changes
  };

  const getCategories = async () => {
    try {
      const resp = await axios.get(`${baseUrl}categories`);
      setCategories(resp?.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getProducts = async () => {
    setLoading(true); // START LOADING
    try {
      const resp = await axios.get(
        `${baseUrl}products?query=${searchQuery}&categoryId=${selectedCategory}&firstResult=${firstResult}&maxResult=${maxResult}`
      );
      const updatedProducts = resp.data.map((product) => ({
        ...product,
        selectedIndex: 0,
        selectedImage: product?.images?.[0] || "",
      }));
      setProducts(updatedProducts);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false); // STOP LOADING
      window.scrollTo({ top: 0, behavior: 'smooth' }); // SCROLL TO TOP
    }
  };


  const onSearch = () => {
    setFirstResult(0); // reset page on new search
    getProducts();
  };

  const handleImageSelect = (productId, image, idx) => {
    const updatedProducts = products.map((product) =>
      product.id === productId ? { ...product, selectedImage: image, selectedIndex: idx } : product
    );
    setProducts(updatedProducts);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleSubmit = async () => {
    const allFieldsFilled = Object.values(formData).every(value =>
      typeof value === 'string' ? value.trim() !== "" : value !== undefined && value !== null
    );

    if (allFieldsFilled) {
      try {
        const resp = await axios.post(`${baseUrl}orders/add`, formData);
        if (resp?.data) {
          message.success("Ordered successfully");
          setFormData({
            name: "",
            mobile: "",
            quantity: "",
            email: "",
            notes: "",
            category_id: "",
            product_id: ""
          });
          setVisible(false);
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      message.error("Please fill in all fields before submitting.");
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const content = (
    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
      <CloseOutlined
        style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }}
        onClick={() => setPopovereVisible(false)}
      />
      <Radio.Group value={selectedCategory} onChange={handleRadioChange} style={{ display: "flex", flexDirection: "column" }}>
        {categories?.map((c) => (
          <Radio key={c?.id} value={c?.id}>{c?.name}</Radio>
        ))}
      </Radio.Group>
      <Button style={{ width: "100%", background: "#f7941d", color: "#fff" }} onClick={() => setSelectedCategory("")}>
        Clear
      </Button>
    </div>
  );

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    getProducts();
  }, [selectedCategory, firstResult]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "#151515",
        color: "#FFF",
        backgroundImage: `url(${greyImage})`
      }}
      ref={headerRef}
    >
      <Header />
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", gap: 30, width: "80%" }}>
        <div style={{ fontWeight: 500, fontSize: 40, textAlign: "left", width: "80%", marginTop: 30 }}>PRODUCTS</div>
        <div style={{ borderBottom: "1px solid #575555", width: "80%" }}></div>

        <div style={{ width: "80%", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
          <div style={{ width: "96%" }}>
            <Search
              placeholder="Search here...."
              onSearch={onSearch}
              enterButton
              style={{ height: 60 }}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div>
            <Popover
              visible={popoverVisible}
              content={content}
              title="Select a category"
              trigger="click"
              onOpenChange={() => setPopovereVisible(true)}
              placement="bottom"
            >
              <FilterIcon style={{ cursor: "pointer",width:"70%" }} />
            </Popover>
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", width: "90%", justifyContent: "center", marginBottom: 100, gap: 20 }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 50 }}>
              <Spin size="large" tip="Loading..." style={{ color: '#f7941d' }} />
            </div>
          ) : (
            <>
              {products?.length === 0 ? (
                <div style={{ color: '#fff', fontSize: 18 }}>No products found.</div>
              ) : (products.map((p) => {
                const isExpanded = expandedPreviews[p.id];
                const previewImages = isExpanded ? p.images : p.images?.slice(0, 4);

                return (
                  <div className="products-card" key={p?.id}>
                    <div style={{
                      fontSize: 24, fontWeight: 500, whiteSpace: "nowrap", textOverflow: "ellipsis",
                      overflow: "hidden", width: "100%", textAlign: "left"
                    }}>{p?.name}</div>

                    <div style={{ width: "100%" }}>
                      <img
                        decoding="async"
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          borderRadius: 4
                        }}
                        src={p?.selectedImage || (p?.images?.length > 0 ? p?.images[0] : "")}
                        alt={p?.name}
                      />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                      {previewImages?.map((i, index) => (
                        <img
                          loading="lazy"
                          decoding="async"
                          key={index}
                          style={{
                            width: "50px", height: "50px", borderRadius: "6px", cursor: "pointer",
                            marginRight: 10, marginBottom: 10,
                            border: index === p?.selectedIndex ? "2px solid #f7941d" : "none"
                          }}
                          src={i}
                          alt={`image-${index}`}
                          onClick={() => handleImageSelect(p.id, i, index)}
                        />
                      ))}
                      {p?.images?.length > 4 && !isExpanded && (
                        <div onClick={() => handleTogglePreview(p.id)} style={{ cursor: "pointer", fontSize: 28, padding: "0 10px", userSelect: "none" }}>
                          ➡
                        </div>
                      )}
                      {p?.images?.length > 4 && isExpanded && (
                        <div onClick={() => handleTogglePreview(p.id)} style={{
                          cursor: "pointer", fontSize: 14, marginLeft: 10,
                          textDecoration: "underline", color: "#f7941d"
                        }}>Show less</div>
                      )}
                    </div>

                    <div className="desc" style={{
                      fontSize: 14, textAlign: "left", width: "100%",
                      height: "100px", overflow: "auto"
                    }}>{p?.description}</div>

                    <div style={{ width: "100%" }}>
                      <Button
                        style={{
                          fontSize: 28, fontWeight: 600, background: "#f7941d",
                          color: "#fff", padding: 20, width: "100%", marginTop: 20, border: "none"
                        }}
                        onClick={() => {
                          setVisible(true);
                          setFormData({
                            ...formData,
                            category_id: p?.categoryId,
                            product_id: p?.id
                          });
                        }}
                      >
                        ORDER NOW
                      </Button>
                    </div>
                  </div>
                );
              }))}
            </>)}
    </div>
<div style={{ marginTop: 10, marginBottom: 40, display: 'flex', gap: 10 }}>
            <Button
              style={{color:"white",background:"black"}}
              disabled={firstResult === 0}
              onClick={() => {
                setFirstResult(prev => Math.max(0, prev - maxResult));
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
              }}
            >
              Previous
            </Button>
            <Button
            style={{color:"white",background:"black"}}
              disabled={products.length < maxResult}
              onClick={() => {
                setFirstResult(prev => prev + maxResult);
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
              }}
            >
              Next
            </Button>
          </div>
        </div>

        {/* Order Modal */}
        <Modal
          title={<div style={{ textAlign: "center", fontSize: "24px", fontWeight: 600, background: "#D9D9D9" }}>Fill the form for order</div>}
          visible={visible}
          onCancel={handleCancel}
          footer={null}
          closable={false}
        >
          <div style={{ display: "flex", flexDirection: "column", background: "#D9D9D9" }}>
            {["Name", "Mobile Number", "Email", "Quantity", "Notes"].map((field, i) => {
              const key = field.toLowerCase().replace(" ", "_");
              return (
                <div key={i} style={{ marginBottom: 16, display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: 8, width: "150px", fontSize: "16px", fontWeight: 600 }}>{field}</label>
                  {field !== "Notes" ? (
                    <Input
                      value={formData[key]}
                      onChange={(e) => handleInputChange(e, key)}
                      placeholder={`Enter ${field}`}
                      style={{ flex: 1, fontSize: "16px", height: "40px", background: "#C2C2C2", color: "#151515" }}
                    />
                  ) : (
                    <TextArea
                      value={formData.notes}
                      onChange={(e) => handleInputChange(e, "notes")}
                      placeholder="Enter Notes"
                      style={{ flex: 1, fontSize: "16px", background: "#C2C2C2", color: "#151515" }}
                    />
                  )}
                </div>
              );
            })}
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
              <Button onClick={handleCancel} style={{ width: "48%", fontSize: "16px", height: "45px", background: "#C2C2C2", color: "#151515" }}>
                Cancel
              </Button>
              <Button type="primary" onClick={handleSubmit} style={{ width: "48%", fontSize: "16px", height: "45px", background: "#f7941d", color: "#fff" }}>
                Order
              </Button>
            </div>
          </div>
        </Modal>

        <Footer />
      </div>
      );
};
